// eslint-disable-next-line import/no-unresolved
import * as CSS from "csstype";
import React from "react";
import { ResponsiveValue, TLengthStyledSystem } from "styled-system";
import { RouterBreadcrumb } from "../../components/RouterBreadcrumb";
import config from "./config.json";

interface Props {
  fontSize?: ResponsiveValue<CSS.Property.FontSize<TLengthStyledSystem>>;
}
export const BreadcrumbContainer: React.FC<Props> = ({ fontSize }) => {
  return <RouterBreadcrumb config={config} fontSize={fontSize} />;
};
